import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { MarketplacePostsFilterSchema } from '@anytag/shared-organisms';

export const MarketplaceEditPostSearchSchema = SearchSchema.create({
  filter: {
    schema: z.object({ draftPost: SearchSchema.types.string() }).merge(MarketplacePostsFilterSchema)
  }
});

export type MarketplaceEditPostSearchSchemaType = z.infer<typeof MarketplaceEditPostSearchSchema>;
